import { SelectMultiOptionWrapper } from "../../../components/Select/SelectMultiOptionWrapper.js";
import { SelectAsyncRPC } from "../../../components/Select/SelectAsyncRPC.js";
import "react";
import { ColorSquare } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { RPCs } from "@therms/rpc-gateway";
//#region src/modules/Events/shared/SelectEventType.tsx
var SelectEventTypeRenderComponents = {
	ListItem: (eventType) => /* @__PURE__ */ jsx("div", {
		className: "inline-flex w-full items-center justify-between",
		children: /* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsxs("span", {
			className: "truncate",
			children: [/* @__PURE__ */ jsx(ColorSquare, {
				color: eventType.color,
				marginRight: true
			}), eventType.name]
		}), /* @__PURE__ */ jsx("div", {
			className: "ellipsis text-color-subtle text-sm tracking-wide capitalize uppercase",
			children: eventType.description
		})] })
	}),
	SelectedMulti: (eventType, onRemove) => /* @__PURE__ */ jsx(SelectMultiOptionWrapper, {
		onRemove,
		children: /* @__PURE__ */ jsxs("div", {
			className: "gap-x-sm px-sm inline-flex max-w-full items-center",
			children: [/* @__PURE__ */ jsx(ColorSquare, { color: eventType.color }), /* @__PURE__ */ jsx("span", {
				className: "truncate",
				children: eventType.name
			})]
		})
	}),
	SelectedSingle: (eventType) => /* @__PURE__ */ jsxs("div", {
		className: "gap-x-sm px-sm inline-flex items-center",
		children: [!!eventType && /* @__PURE__ */ jsx(ColorSquare, { color: eventType.color }), /* @__PURE__ */ jsx("span", {
			className: "truncate",
			children: eventType.name
		})]
	})
};
var responseOptionsExtractor = (data) => data?.eventTypes;
var SelectEventType = ({ eventTypeIds, limit = 15, multi, value, ...atalayaSelectProps }) => {
	return /* @__PURE__ */ jsx(SelectAsyncRPC, {
		RenderListItem: SelectEventTypeRenderComponents.ListItem,
		RenderSelectedMulti: SelectEventTypeRenderComponents.SelectedMulti,
		RenderSelectedSingle: SelectEventTypeRenderComponents.SelectedSingle,
		args: { eventTypeIds },
		idProp: "id",
		limit,
		multi,
		optionLabelExtractor: ({ name }) => name,
		optionValueExtractor: ({ id }) => id,
		request: RPCs.Events.GetEventTypesList.v1,
		requestFilterProp: "eventTypeIds",
		responseOptionsExtractor,
		value,
		...atalayaSelectProps
	});
};
//#endregion
export { SelectEventType, SelectEventTypeRenderComponents };

//# sourceMappingURL=SelectEventType.js.map